// extracted by mini-css-extract-plugin
export default {"cardClass":"OrderReview_cardClass__Cnd2D","main-image":"OrderReview_main-image__gr0wR","content":"OrderReview_content__IY16k","action":"OrderReview_action__h05G-"};